import { render, staticRenderFns } from "./TicketboardOverview.vue?vue&type=template&id=6e149f6f&scoped=true&"
import script from "./TicketboardOverview.vue?vue&type=script&lang=js&"
export * from "./TicketboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./TicketboardOverview.vue?vue&type=style&index=0&id=6e149f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e149f6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTextField})
